import { render, staticRenderFns } from "./contentProductionHome.vue?vue&type=template&id=48a0d882&scoped=true&"
import script from "./contentProductionHome.vue?vue&type=script&lang=js&"
export * from "./contentProductionHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0d882",
  null
  
)

export default component.exports